function getTranslatedText(texts, id, lang) {
  return (
    <span style={{ direction: lang === "ar" ? "rtl" : "ltr" }}>
      {texts[id][lang]}
    </span>
  );
}

export default getTranslatedText;
